import { render, staticRenderFns } from "./BankruptcyList.vue?vue&type=template&id=40f91b78&scoped=true&"
import script from "./BankruptcyList.vue?vue&type=script&lang=js&"
export * from "./BankruptcyList.vue?vue&type=script&lang=js&"
import style0 from "./BankruptcyList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BankruptcyList.vue?vue&type=style&index=1&id=40f91b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f91b78",
  null
  
)

export default component.exports